<template>
  <div class="as-player-team">
    <div v-if="match && match.home_team" class="as-player-team-item">
      <img
        :src="
          getImgUrlBySport('team', match.home_team.id)
        "
      />
      <div class="as-player-team-name">
        {{ match.home_team.name }}
      </div>
    </div>
    <div v-if="match && match.away_team" class="as-player-team-item">
      <div class="as-player-team-name">
        {{ match.away_team.name }}
      </div>
      <img
        :src="getImgUrlBySport('team', match.away_team.id)"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { defineProps } from "vue";
import type {
  ILineups,
  IMatch,
  IPlayer,
  IIncidentStatistic,
} from "~src/interfaces";
import { formatRateColor } from "~src/helpers";

interface IProps {
  match: IMatch;
  lineups: ILineups;
}

const props = withDefaults(defineProps<IProps>(), {});

</script>

<script lang="ts">
export default {};
</script>
